// Copyright 2020 Prescryptive Health, Inc.

import { ErrorDispatch } from './error.dispatch';
import { fatalErrorSetAction } from '../actions/fatal-error-set.action';

export const fatalErrorDispatch = (dispatch: ErrorDispatch): void => {
  dispatch(fatalErrorSetAction());
};
